import React, { useState, useEffect, useRef } from "react";
import "./Services.css";
import AOS from "aos";
import "aos/dist/aos.css";

const services = [
  {
    id: 1,
    title: "Modular Operation Theatre ",
    subtitle: "Turnkey Modular OT Setup in Pune & India",
    description:
      "Complete modular operation theatre solutions with laminar airflow, sterile environment, OT pendants, surgical lighting, hermetically sealed doors, and NABH-compliant design.",
    image: "/assets/services/ssmodular-operation-theaters.webp",
  },
  {
    id: 2,
    title: "Modular ICU",
    subtitle: "Advanced ICU Infrastructure Setup",
    description:
      "Comprehensive modular ICU solutions with patient monitoring systems, life support equipment integration, infection control, and critical care infrastructure.",
    image: "/assets/services/icu.webp",
  },
  {
    id: 3,
    title: "Modular NICU & PICU Setup ",
    subtitle: "Critical Care ICU Infrastructure Pune",
    description:
      "Advanced NICU & PICU setups with infection control systems, monitoring integration, oxygen supply systems, and patient safety infrastructure.",
    image: "/assets/services/Modular-NICU-PICU.webp",
  },
  {
    id: 4,
    title: "IVF Centre Setup ",
    subtitle: "Fertility Clinic Cleanroom Design Pune",
    description:
      "Turnkey IVF centre design with HEPA filtration, controlled environment systems, humidity regulation, and sterile lab conditions.",
    image: "/assets/services/ivf.webp",
  },
  {
    id: 5,
    title: "Cathlab Installation ",
    subtitle: "Cardiac Cathlab Turnkey Setup Pune",
    description:
      "Advanced cathlab installation with imaging integration, radiation shielding, sterile airflow systems, and cardiac care infrastructure.",
    image: "/assets/services/cathlab.webp",
  },
  {
    id: 6,
    title: "Operation Theatre Doors",
    subtitle: "Hermetically Sealed OT Doors India",
    description:
      "Automatic sliding and swing OT doors with airtight sealing, infection control, radiation protection, and smooth operation.",
    image: "/assets/services/ot-door.webp",
  },
  {
    id: 7,
    title: "Laminar Air Flow System",
    subtitle: "Sterile Airflow for Modular OT Pune",
    description:
      "Laminar airflow systems ensuring sterile unidirectional airflow for operation theatres, ICUs, and cleanroom environments.",
    image: "/assets/services/laminar-air-flow.webp",
  },
  {
    id: 8,
    title: "Medical Air Purifier",
    subtitle: "HEPA Filtration Hospital System Pune",
    description:
      "Multi-stage HEPA filtration air purifiers designed for hospitals, operation theatres, and ICUs.",
    image: "/assets/services/air-sterilizer.webp",
  },
  {
    id: 9,
    title: "Antibacterial Stretch Ceiling",
    subtitle: "Modular OT Ceiling System India",
    description:
      "Seamless antibacterial ceiling systems for operation theatres and sterile hospital corridors.",
    image: "/assets/services/antibacterial-stretch.webp",
  },
  {
    id: 10,
    title: "Clean Room Project",
    subtitle: "Turnkey Cleanroom Setup India",
    description:
      "Complete cleanroom solutions for hospitals, pharma, and labs with controlled air quality and pressure systems.",
    image: "/assets/services/turnkey-project-for-clean-room.webp",
  },
  {
    id: 11,
    title: "Surgical Scrub Sink",
    subtitle: "Sensor Operated Hospital Sink Pune",
    description:
      "Stainless steel scrub sinks with sensor, elbow, and knee-operated hygienic systems.",
    image: "/assets/services/surgical-scrub-sink.webp",
  },
  {
    id: 12,
    title: "OT Pass Box",
    subtitle: "Contamination-Free Transfer Unit",
    description:
      "Static and dynamic pass boxes with HEPA filtration for sterile material transfer.",
    image: "/assets/services/passbox.webp",
  },
  {
    id: 13,
    title: "Hospital Vinyl Flooring",
    subtitle: "Anti-Static Flooring Pune Hospitals",
    description:
      "Anti-bacterial, anti-static vinyl flooring with chemical resistance for hospitals and OTs.",
    image: "/assets/services/Vinyl-Flooring.webp",
  },
  {
    id: 14,
    title: "OT Pendants",
    subtitle: "Modular OT Equipment System Pune",
    description:
      "Ceiling-mounted pendants with gas outlets, electrical systems, and surgical arms.",
    image: "/assets/services/ot_pendant.webp",
  },
  {
    id: 15,
    title: "Hospital Ducting System",
    subtitle: "HVAC Air Distribution Pune",
    description:
      "Leak-proof HVAC ducting systems for controlled airflow and infection prevention.",
    image: "/assets/services/hosp_ducting.jpg",
  },
  {
    id: 16,
    title: "Hospital AHU System",
    subtitle: "Air Handling Unit for OT Pune",
    description:
      "Double skin AHU systems for temperature, humidity, and air quality control.",
    image: "/assets/services/hosp_ahu.webp",
  },
  {
    id: 17,
    title: "Surgeon Control Panel",
    subtitle: "Smart OT Control System India",
    description:
      "Advanced control panels for managing OT lighting, airflow, alarms, and systems.",
    image: "/assets/services/Surgeon-Control-Panel.webp",
  },
  {
    id: 18,
    title: "Epoxy Flooring Work",
    subtitle: "Medical Grade Hospital Flooring Pune",
    description:
      "Seamless epoxy flooring with chemical resistance and anti-bacterial properties.",
    image: "/assets/services/epoxy-work.webp",
  },
];

function Services() {
  const [selected, setSelected] = useState(services[0]);
  const [fullscreenImg, setFullscreenImg] = useState(null);
  const [slideIndex, setSlideIndex] = useState(0);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const firstFour = services.slice(0, 4);
  const sliderServices = services.slice(4);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setSlideIndex((prev) => (prev + 1) % sliderServices.length);
  };

  const prevSlide = () => {
    setSlideIndex(
      (prev) => (prev - 1 + sliderServices.length) % sliderServices.length,
    );
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;

    const distance = touchStartX.current - touchEndX.current;

    if (distance > 50) nextSlide();
    if (distance < -50) prevSlide();
  };

  return (
    
    <section className="srv-page" id="services">
      <div className="srv-header" data-aos="fade-up">
        <span className="srv-tag">What We Offer</span>
        <h2>
          Our <span>Services</span>
        </h2>
        <p>Advanced Modular OT & Hospital Infrastructure Solutions</p>
      </div>

      {/* Desktop */}
      <div className="srv-layout">
        <aside className="srv-sidebar">
          {services.map((svc) => (
            <button
              key={svc.id}
              className={`srv-item ${selected.id === svc.id ? "active" : ""}`}
              onClick={() => setSelected(svc)}
            >
              {svc.title}
            </button>
          ))}
        </aside>

        <div className="srv-panel">
          <div
            className="srv-img-wrap"
            onClick={() => setFullscreenImg(selected.image)}
          >
            <img src={selected.image} alt={selected.title} />
          </div>

          <div className="srv-content">
            <h3>{selected.title}</h3>
            <p className="sub">{selected.subtitle}</p>
            <p>{selected.description}</p>
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="srv-mobile">
        {firstFour.map((svc) => (
          <div className="srv-mob-card" key={svc.id}>
            <div
              className="srv-mob-img-wrap"
              onClick={() => setFullscreenImg(svc.image)}
            >
              <img src={svc.image} alt={svc.title} />
            </div>
            <div className="srv-mob-info">
              <h4>{svc.title}</h4>
              <p>{svc.subtitle}</p>
            </div>
          </div>
        ))}

        {/* Slider */}
        <div
          className="srv-slider-wrapper"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          {sliderServices.map((svc, i) => (
            <div
              key={svc.id}
              className={`srv-slide ${i === slideIndex ? "active" : ""}`}
            >
              <div
                className="srv-mob-img-wrap"
                onClick={() => setFullscreenImg(svc.image)}
              >
                <img src={svc.image} alt={svc.title} />
              </div>

              <div className="srv-mob-info">
                <h4>{svc.title}</h4>
                <p>{svc.subtitle}</p>
              </div>
            </div>
          ))}

          <div className="srv-slider-dots">
            {sliderServices.map((_, i) => (
              <button
                key={i}
                className={`srv-dot ${i === slideIndex ? "active" : ""}`}
                onClick={() => setSlideIndex(i)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Fullscreen modal */}
      {fullscreenImg && (
        <div className="srv-modal" onClick={() => setFullscreenImg(null)}>
          <img src={fullscreenImg} alt="fullscreen" />
          <button className="srv-close" onClick={() => setFullscreenImg(null)}>
            ✕
          </button>
        </div>
      )}
    </section>
  );
}

export default Services;
